import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { Agreement } from "../interfaces/agreement.interface";

@Injectable()
export class AgreementsService {
  constructor(private http: HttpClientService) {}

  public post(agreement: any): Observable<any> {
    return this.http.post("/api/agreements", agreement).pipe(tap((_) => console.log("AgreementsService.post: Ok.")));
  }

  public delete(id): Observable<any> {
    return this.http.delete(`/api/agreements/${  id}`).pipe(tap((_) => console.log("AgreementsService.delete: Ok.")));
  }

  public updateAgreement(agreement: any) {
    const options = {
      agreement,
    };
    return this.http
      .put(`/api/agreements/${  agreement.id}`, options)
      .pipe(tap((_) => console.log("AgreementsService.updateAgreement: Ok.")));
  }

  public getAgreements(): Observable<Agreement[]> {
    return this.http
      .get<Agreement[]>("/api/agreements")
      .pipe(tap((_) => console.log("AgreementsService.getAgreements: Ok.")));
  }

  public getAll(filters): Observable<any[]> {
    const options = {
      params: filters,
    };
    return this.http.get("/api/agreements/all", options).pipe(tap((_) => console.log("AgreementsService.getAll: Ok.")));
  }

  public dealershipsByAgreement(filters): Observable<any[]> {
    const options = {
      params: filters,
    };
    return this.http
      .get("/api/agreements/dealerships_by_agreement", options)
      .pipe(tap((_) => console.log("AgreementsService.dealershipsByAgreement: Ok.")));
  }

  public checkDealerships(ids): Observable<any[]> {
    const options = { ids };
    return this.http
      .post("/api/agreements/check_dealerships", options)
      .pipe(tap((_) => console.log("AgreementsService.checkDealerships: Ok.")));
  }

  public updateDealershipsByBatches(ids, agreement_id): Observable<any[]> {
    const options = { ids, agreement_id };
    return this.http
      .post("/api/agreements/update_dealerships_by_batches", options)
      .pipe(tap((_) => console.log("AgreementsService.updateDealershipsByBatches: Ok.")));
  }
}
